import Api from './Api';

class LogicBaseAppPinApi extends Api {
  url = 'logicbaseapppins';
}

const singleton = new LogicBaseAppPinApi();
export default singleton;
